import { render, staticRenderFns } from "./VBrokerRestrictCard.vue?vue&type=template&id=705d8f6e&scoped=true"
import script from "./VBrokerRestrictCard.vue?vue&type=script&lang=js"
export * from "./VBrokerRestrictCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d8f6e",
  null
  
)

export default component.exports